import React, { useState } from "react";
import { AlertTriangle, ChevronDown, ChevronUp, Calendar } from "lucide-react";
import { usePendingAlerts } from "../hooks/usePendingAlerts";

const PendingExcursionsAlert = ({ userRole, onSelectDate }) => {
  const { alerts, isLoading } = usePendingAlerts(userRole);
  const [isExpanded, setIsExpanded] = useState(false);

  if (isLoading || alerts.length === 0) return null;

  return (
    <div className="mb-6 rounded-lg border-l-4 border-orange-500 bg-orange-50 dark:bg-orange-950/20 shadow-sm overflow-hidden">
      <div 
        className="p-4 flex items-center justify-between cursor-pointer hover:bg-orange-100/50 dark:hover:bg-orange-900/20 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-3 text-orange-800 dark:text-orange-400">
          <AlertTriangle className="h-5 w-5 shrink-0" />
          <div>
            <h3 className="font-semibold text-sm">
              Atenção: {alerts.length} {alerts.length === 1 ? "excursão exige" : "excursões exigem"} confirmação
            </h3>
            <p className="text-xs opacity-90 mt-0.5">
              Excursões agendadas para dias de semana ou com pacote incluso.
            </p>
          </div>
        </div>
        <button className="text-orange-600 hover:text-orange-800 dark:text-orange-500 dark:hover:text-orange-300 transition-colors p-1">
          {isExpanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
        </button>
      </div>

      {isExpanded && (
        <div className="bg-white dark:bg-card border-t border-orange-200 dark:border-orange-900/50 p-4">
          <ul className="space-y-2">
            {alerts.map((excursion) => (
              <li 
                key={excursion.id}
                className="flex items-center justify-between p-3 rounded-md bg-orange-50/50 dark:bg-orange-900/10 border border-orange-100 dark:border-orange-900/30 hover:border-orange-300 dark:hover:border-orange-700 transition-colors cursor-pointer"
                onClick={() => onSelectDate(excursion.excursionDate)}
                title="Clique para ir até a data desta excursão"
              >
                <div className="flex flex-col pr-3">
                  <span className="font-medium text-sm text-slate-800 dark:text-slate-200 line-clamp-2">
                    {excursion.clientName || "Cliente sem nome"}
                  </span>
                  <span className="text-xs text-orange-700 dark:text-orange-500 mt-1">
                    Motivo: {excursion.reason}
                  </span>
                </div>
                <div className="shrink-0 whitespace-nowrap flex items-center gap-2 text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-800 px-3 py-1.5 rounded-full text-xs font-medium border border-slate-200 dark:border-slate-700 shadow-sm">
                  <Calendar className="shrink-0 h-3.5 w-3.5" />
                  {excursion.excursionDate.toLocaleDateString("pt-BR", {
                    weekday: "short",
                    day: "2-digit",
                    month: "2-digit"
                  })}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PendingExcursionsAlert;
